import { MiaPlaza } from '@/Reinforced.Typings';
/**
 * Convenience class for getting Grade specific information.
 */
 export default class GradeHelper {
	public static OrdinalName(grade: MiaPlaza.Model.Grades.Grade): string {
		return `${MiaPlaza.LO.GradeName.ORDINAL_PREFIX}${grade}`;
	}

	public static VerboseName(grade: MiaPlaza.Model.Grades.Grade): string {
		return `${MiaPlaza.LO.GradeName.VERBOSE_PREFIX}${grade}`;
	}

	public static VerboseVocabularyName(grade: MiaPlaza.Model.Grades.Grade): string {
		return `${MiaPlaza.LO.GradeName.VERBOSE_VOCABULARY_PREFIX}${grade}`;
	}

	public static CardinalName(grade: MiaPlaza.Model.Grades.Grade): string {
		return `${MiaPlaza.LO.GradeName.CARDINAL_PREFIX}${grade}`;
	}

	public static RecommendedGradeTR(gradeMinText: string, gradeMaxText: string): string {
		const isSingular = gradeMinText === gradeMaxText;

		const textResourse: any = {
			key: isSingular
				? 'selectablecourse_recommendedgraderange_singular'
				: 'selectablecourse_recommendedgraderange', 
		};

		if (isSingular) {
			textResourse["grade"] = gradeMinText;
		} else {
			textResourse["gradeMin"] = gradeMinText;
			textResourse["gradeMax"] = gradeMaxText;
		}

		return textResourse;
	}
}
